import type { Skill } from '../types';

export const skills: Skill[] = [
  {
    icon: 'Gamepad2',
    label: 'Game Development',
    description: 'Unity3D | C# | Level Design | Game Mechanics',
  },
  {
    icon: 'Box',
    label: '3D Modeling',
    description: 'Blender | Texturing',
  },
  {
    icon: 'Eye',
    label: 'Computer Vision',
    description: 'OpenCV | Python | Parking Space Detection System',
  },
];
